import { createActionNamespace } from 'Modules/core/redux';

import { Upload, Progress } from './types';


const uploadsAction = createActionNamespace('uploads');

export const uploadsActions = {
    upload: uploadsAction<Upload>('UPLOAD'),
    progressUpload: uploadsAction<Progress>('PROGRESS_UPLOAD'),
    finishUpload: uploadsAction<Progress['id']>('FINISH_UPLOAD'),
};
